import { createFileRoute, Outlet, useParams } from '@tanstack/react-router';
import { ContactPage, prefetchContactPage } from './-components/contact/page';
import { DEFAULT_NGO_TAB, parseAudience, parseTab } from './-components/contact/audiences';

/**
 * The Contact page's shell, and the parent of the four audience pages.
 *
 * The audience is read off the CHILD's param rather than passed down from it, so the shell owns the
 * whole page and the child route contributes only its own head. `strict: false` because that param
 * exists on `/new/contact/$audience` and not on `/new/contact/`, which is the audience-less chooser —
 * it comes back undefined there, and `parseAudience` answers null for anything that is not one of the
 * four, so a hand-typed segment cannot reach a questionnaire.
 */
export const Route = createFileRoute('/new/contact')({
	loader: ({ context }) => prefetchContactPage(context),
	component: Component,
});

function Component() {
	const { audience, tab } = useParams({ strict: false });
	const parsed = parseAudience(audience);

	return (
		// The tab comes from the URL alone, so the server and the client choose the same one — a tab
		// picked from anything the server cannot see would render one panel in the HTML and another
		// after hydration.
		<ContactPage audience={parsed} tab={parseTab(parsed, tab) ?? DEFAULT_NGO_TAB}>
			<Outlet />
		</ContactPage>
	);
}
